import React from 'react';
import { styled } from '@mui/material';
import { RText } from './RText';

interface REmptyTextProps {
    children: React.ReactNode;
    padding?: string;
}

export function REmptyText({ children, padding = '40px 0' }: REmptyTextProps) {
    return (
        <Wrapper style={{ padding }}>
            <RText component="p" tone="secondary" align="center">
                {children}
            </RText>
        </Wrapper>
    );
}

const Wrapper = styled('div')({});
